import { getToken } from './local.storage';
import { isEmpty, forEach } from 'lodash';
import { API_HOST } from '../constants/settings';

export async function apiRequest(method, url, options = { skipToken: false, body: {} }) {
    let status;
    try {
        const request = await fetch(`${_getHost()}${url}`, {
            headers: _headers(options.skipToken, options.noJson),
            method: method,
            mode: 'cors',
            body: !isEmpty(options.body) ? JSON.stringify(options.body) : undefined
        });
        status = await request.status;
        const json = await request.json();
        return { status, json };
    } catch (e) {
        return { status: status || 503, json: { message: e.message || 'Service Unavailable' } };
    }
}

export async function formRequest(method, url, formBody) {
    var data = new FormData();
    forEach(formBody, (v, k) => data.append(k, v));
    fetch(_getHost() + url, {
        method: method,
        headers: {
            Authorization: `Bearer ${getToken()}`
        },
        body: data
    });
}

function _getHost() {
    let host = API_HOST[process.env.REACT_APP_CKP_ENV || 'local'];
    if (!host) host = 'api/v1';
    return host;
}
function _headers(skipToken) {
    const defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const authorization = skipToken ? {} : { Authorization: `Bearer ${getToken()}` };
    return { ...defaultHeaders, ...authorization };
}



// WEBPACK FOOTER //
// ./src/services/helpers.js